import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  CalendarDays,
  MapPin,
  BookOpen,
  HeartHandshake,
  Users,
  Church,
  CreditCard,
  Hotel,
  CheckCircle2,
  Clock3,
} from "lucide-react";

import Fortified2 from "../assets/images/events/optizimized/fortified2.webp";
import BridgeHerImage from "../assets/woman.JPG";
import { Helmet } from "react-helmet";


export default function Retreats() {

const retreatDate = new Date("2027-02-12T00:00:00");

const formattedDate = retreatDate.toLocaleDateString("en-US", {
  month: "long",
  day: "numeric",
  year: "numeric",
});

const [timeLeft, setTimeLeft] = useState({
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
});

useEffect(() => {
  const updateCountdown = () => {
    const now = new Date().getTime();
    const distance = retreatDate.getTime() - now;

    if (distance <= 0) {
      setTimeLeft({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      });
      return;
    }

    setTimeLeft({
      days: Math.floor(distance / (1000 * 60 * 60 * 24)),
      hours: Math.floor(
        (distance % (1000 * 60 * 60 * 24)) /
          (1000 * 60 * 60)
      ),
      minutes: Math.floor(
        (distance % (1000 * 60 * 60)) /
          (1000 * 60)
      ),
      seconds: Math.floor(
        (distance % (1000 * 60)) / 1000
      ),
    });
  };

  updateCountdown();

  const interval = setInterval(updateCountdown, 1000);

  return () => clearInterval(interval);
}, []);

  const navigate = useNavigate();

  const benefits = [
    "Close communication gaps",
    "Diffuse misunderstandings",
    "Strengthen marriages",
    "Build stronger families",
    "Navigate difficult relationships",
    "Strengthen parent-child relationships",
    "Understand emotional triggers",
    "Grow spiritually together",
  ];

  const attendees = [
    {
      icon: <HeartHandshake size={36} />,
      title: "Married Couples",
      text: "Strengthen communication, deepen intimacy, and build lasting unity.",
    },
    {
      icon: <Users size={36} />,
      title: "Singles",
      text: "Learn healthy communication, emotional awareness, and biblical relationship principles.",
    },
    {
      icon: <Church size={36} />,
      title: "Families",
      text: "Develop stronger parent-child relationships and healthier family dynamics.",
    },
    {
      icon: <BookOpen size={36} />,
      title: "Leaders",
      text: "Gain practical tools for ministry, business, and everyday relationships.",
    },
  ];

  const speakers = [
    "Maurice Johnson",
    "Kim Johnson",
    "Coach Consuello Hodges",
    "David Beaver",
    "Brenetia Adams-Robinson",
    "Lolita Martin",
    "Cloretta Chandler",
    "Devita Shaw",
    "Quintavious Johnson",
  ];


  const events = [
    {
      title: "Marriage Retreat",
      location: "Coming Soon",
      date: "2026",
    },
    {
      title: "Marriage Conference",
      location: "Coming Soon",
      date: "2026",
    },
    {
      title: "Couples Experience",
      location: "Coming Soon",
      date: "2026",
    },
  ];

  return (
    <>
    <Helmet>
  <title>
    Fortified Relationship Retreat 2027 | Pure Business Solutions
  </title>

  <meta
    name="description"
    content="Join the Fortified Relationship Retreat on February 12–14, 2027, in Clarksville, Tennessee. Experience biblical teaching, worship, relationship coaching, and practical tools designed to strengthen marriages, families, and every meaningful relationship."
  />

  <meta
    name="keywords"
    content="Fortified Relationship Retreat, Christian marriage retreat, relationship retreat, couples retreat Tennessee, marriage conference, biblical relationship coaching, Christian couples retreat, family retreat, Pure Business Solutions, Maurice Johnson, Kim Johnson"
  />

  <meta
    name="author"
    content="Pure Business Solutions"
  />

  <link
    rel="canonical"
    href="https://www.pbizs.com/retreats"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Fortified Relationship Retreat 2027"
  />

  <meta
    property="og:description"
    content="Experience three unforgettable days of worship, biblical teaching, coaching, healing, and practical relationship strategies in Clarksville, Tennessee."
  />

  <meta
    property="og:image"
    content="https://www.pbizs.com/logo512.png"
  />

  <meta
    property="og:url"
    content="https://www.pbizs.com/retreats"
  />

  <meta
    property="og:type"
    content="website"
  />

  {/* Twitter */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content="Fortified Relationship Retreat 2027"
  />

  <meta
    name="twitter:description"
    content="Strengthen your marriage, family, and relationships through a Christ-centered retreat with Maurice and Kim Johnson."
  />

  <meta
    name="twitter:image"
    content="https://www.pbizs.com/logo512.png"
  />
</Helmet>
    x
    <main className="bg-[#FFFDF9] overflow-hidden">
      <section className="relative bg-gradient-to-br from-[#EEF8FF] via-white to-[#F8F3ED] py-24 lg:py-36 px-6 overflow-hidden">

        <div className="pointer-events-none absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-[#D4AF37]/10 blur-3xl"></div>

        <div className="pointer-events-none absolute bottom-0 left-0 w-[450px] h-[450px] rounded-full bg-[#A8D5FF]/20 blur-3xl"></div>

        <div className="relative z-10 max-w-7xl mx-auto grid lg:grid-cols-2 gap-20 items-center">

          <div>

            <span className="uppercase tracking-[6px] text-[#D4AF37] font-semibold">

              2027 FEATURED EVENT

            </span>

            <h1 className="text-5xl lg:text-7xl font-bold text-[#2C2C2C] leading-tight mt-6">

              Fortified
              <br />
              Relationship
              <br />
              Retreat

            </h1>

            <div className="w-32 h-1 bg-[#D4AF37] rounded-full my-8"></div>

            <p className="text-xl leading-9 text-gray-600">

              Three unforgettable days of biblical teaching,
              worship, coaching, healing, and practical
              relationship strategies designed to strengthen
              every area of your life.

            </p>

            <div className="space-y-4 mt-10 text-lg">

            <div className="flex items-center gap-3">
              <CalendarDays className="text-[#D4AF37]" />
              {formattedDate}
            </div>

              <div className="flex items-center gap-3">

                <MapPin className="text-[#D4AF37]" />

                DoubleTree by Hilton Clarksville Riverview

              </div>

            </div>

            <div className="flex flex-wrap gap-5 mt-12">

            <button
              onClick={() =>
                window.open(
                  "https://www.eventbrite.com/e/fortified-relationship-retreat-tickets-1988493676114",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
              className="bg-[#D4AF37] hover:bg-[#BE9924] text-white px-10 py-4 rounded-full font-semibold transition"
            >
              Register Now
            </button>

              <button
                onClick={() => navigate("/contact")}
                className="border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white px-10 py-4 rounded-full font-semibold transition"
              >

                Contact Us

              </button>

            </div>

          </div>

          <div>

            <div>

              {/* Replace with retreat image */}

              <div className="rounded-[40px] overflow-hidden shadow-2xl">

                <img
                  src={Fortified2}
                  alt=""
                  className="w-full h-full object-cover"
                />

              </div>

            </div>

          </div>

        </div>
          <div className="flex flex-col items-center max-w-7xl mx-auto mt-24">

            <span className="uppercase tracking-[5px] text-[#D4AF37] font-semibold">
              Welcome
            </span>

            <h2 className="text-5xl lg:text-6xl font-bold text-[#2C2C2C] mt-5 leading-tight">
              More Than
              Just Another Retreat
            </h2>

            <div className="w-[80%] h-1 bg-[#D4AF37] rounded-full my-8"></div>

            <div className="max-w-none space-y-8 text-lg text-gray-600 leading-9">

              <p>
                There is something powerful on the horizon that is designed to
                strengthen families, heal relationships, and transform lives.
              </p>

              <p>
                Inspired by Ephesians 4:1–6, the Fortified Relationship Retreat
                provides practical biblical strategies for marriages, families,
                ministry, friendships, and every meaningful relationship.
              </p>

              <p>
                Whether you're married, single, engaged, serving in ministry,
                leading in business, or simply desiring healthier relationships,
                this weekend was created with you in mind.
              </p>

            </div>

          </div>
        {/* Registration Info */}


        <div className="relative z-20 max-w-7xl mx-auto mt-12">
          <div className="bg-white rounded-[28px] shadow-xl border border-[#E8E8E8] p-8">

          <h3 className="text-2xl font-bold text-[#2C2C2C]">
            How to Register
          </h3>

          <div className="w-16 h-1 bg-[#D4AF37] rounded-full my-4"></div>

          <div className="space-y-6 text-gray-600 leading-8">

            <div>
              <p className="font-semibold text-[#2C2C2C]">
                Step 1
              </p>

              <p>
                Register through Eventbrite by completing your attendee information.
              </p>
            </div>

            <div>
              <p className="font-semibold text-[#2C2C2C]">
                Step 2
              </p>

              <p>
                Submit your payment using one of the options below.
              </p>
            </div>

            <div className="bg-[#F8F3ED] rounded-2xl p-5">

              <p>
                <strong>Cash App:</strong> $purepartner4life
              </p>

              <p className="mt-2">
                <strong>Zelle:</strong> 931-220-2796
              </p>

              <p className="mt-4 text-sm text-gray-500">
                Need another payment option?
                <br />
                Send us a direct message.
              </p>

            </div>

          </div>

          <div className="flex flex-wrap gap-4 mt-8">

          <button
            onClick={() =>
              window.open(
                "https://www.eventbrite.com/e/fortified-relationship-retreat-tickets-1988493676114",
                "_blank",
                "noopener,noreferrer"
              )
            }
            className="inline-flex items-center justify-center rounded-full bg-[#D4AF37] px-8 py-4 text-lg font-bold text-white transition-all duration-300 hover:bg-[#BE9924] hover:scale-105 shadow-lg"
          >
            🎟️ Register on Eventbrite
          </button>

            <button
              onClick={() => navigate("/contact")}
              className="border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white px-8 py-4 rounded-full font-semibold transition"
            >
              Questions?
            </button>

          </div>
            </div>
        </div>
      </section>
      {/* ========================================= */}
      {/* COUNTDOWN */}
      {/* ========================================= */}

      <section className="bg-[#16324F] py-24 px-6">

        <div className="max-w-7xl mx-auto text-center">

          <span className="uppercase tracking-[5px] text-[#D4AF37] font-semibold">
            Mark Your Calendars
          </span>

          <h2 className="text-5xl md:text-6xl font-bold text-white mt-6">
            Put In Your
            <br />
            Time-Off Requests!
          </h2>

          <p className="text-xl text-white/80 mt-8 max-w-3xl mx-auto leading-8">
            The Fortified Relationship Retreat returns to Clarksville,
            Tennessee for an unforgettable weekend of growth,
            healing, worship, and biblical relationship coaching.
          </p>

          {/* Countdown */}

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-16">

            <div className="bg-white/10 rounded-[30px] py-10">
              <h3 className="text-6xl font-bold text-[#D4AF37]">
                {timeLeft.days}
              </h3>

              <p className="uppercase tracking-[3px] text-white mt-4">
                Days
              </p>
            </div>

            <div className="bg-white/10 rounded-[30px] py-10">
              <h3 className="text-6xl font-bold text-[#D4AF37]">
                {timeLeft.hours}
              </h3>

              <p className="uppercase tracking-[3px] text-white mt-4">
                Hours
              </p>
            </div>

            <div className="bg-white/10 rounded-[30px] py-10">
              <h3 className="text-6xl font-bold text-[#D4AF37]">
                {timeLeft.minutes}
              </h3>

              <p className="uppercase tracking-[3px] text-white mt-4">
                Minutes
              </p>
            </div>

            <div className="bg-white/10 rounded-[30px] py-10">
              <h3 className="text-6xl font-bold text-[#D4AF37]">
                {timeLeft.seconds}
              </h3>

              <p className="uppercase tracking-[3px] text-white mt-4">
                Seconds
              </p>
            </div>

          </div>

          {/* Early Bird */}

          <div className="mt-20 inline-block bg-[#D4AF37] rounded-full px-10 py-5 shadow-xl">

            <p className="text-white font-bold text-lg">
              🎉 Early Bird Pricing Ends July 31, 2026
            </p>

          </div>

        </div>

      </section>
      
        <section className="py-28 px-6 bg-[#F8F3ED]">

        <div className="max-w-7xl mx-auto">

          <div className="text-center">

            <span className="uppercase tracking-[5px] text-[#D4AF37] font-semibold">
              Upcoming Ministry Events
            </span>

            <h2 className="text-5xl font-bold text-[#2C2C2C] mt-5">
              Continue Growing
              <br />
              Throughout The Year
            </h2>

            <div className="w-24 h-1 bg-[#D4AF37] rounded-full mx-auto my-8"></div>

            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-9">
              In addition to our relationship retreats, Maurice and Kim participate
              in conferences, leadership gatherings, and ministry events designed
              to encourage spiritual growth and strengthen the Body of Christ.
            </p>

          </div>

        </div>

      </section>
      {/* ================= BRIDGEHER ENCOUNTER ================= */}

<section className="py-28 px-6 bg-white">

  <div className="max-w-7xl mx-auto">

    <div className="text-center">

      <span className="uppercase tracking-[5px] text-[#BE2D69] font-semibold">
        Featured Women's Event
      </span>

      <h2 className="text-5xl font-bold text-[#2C2C2C] mt-5">
        BRIDGEHER Encounter 2026
      </h2>

      <div className="w-24 h-1 bg-[#BE2D69] rounded-full mx-auto my-8"></div>

    </div>

    <div className="grid lg:grid-cols-2 gap-16 items-center mt-16">

      {/* Image */}

      <div>

        <img
          src={BridgeHerImage}
          alt="BRIDGEHER Encounter 2026"
          className="rounded-[35px] shadow-2xl w-full"
        />

      </div>

      {/* Content */}

      <div>

        <span className="inline-block bg-[#FCEAF2] text-[#BE2D69] px-5 py-2 rounded-full font-semibold">
          October 9–11, 2026
        </span>

        <h3 className="text-4xl font-bold text-[#2C2C2C] mt-8">
          Where Generations Meet
        </h3>

        <p className="text-lg text-gray-600 leading-9 mt-8">

          BRIDGEHER Encounter 2026 brings women of every generation
          together to heal, connect, mentor, and grow in Christ.
          Through worship, breakout sessions, panel discussions,
          fellowship, and brunch, women will experience restoration,
          encouragement, and lasting relationships.

        </p>

        <div className="grid grid-cols-2 gap-5 mt-10">

          <div className="bg-[#d8a175] rounded-2xl p-5">
            📅
            <h4 className="font-bold mt-3">October 9–11</h4>
          </div>

          <div className="bg-[#d8a175] rounded-2xl p-5">
            💜
            <h4 className="font-bold mt-3">$75 Registration</h4>
          </div>

          <div className="bg-[#d8a175] rounded-2xl p-5">
            ☕
            <h4 className="font-bold mt-3">Brunch Included</h4>
          </div>

          <div className="bg-[#d8a175] rounded-2xl p-5">
            🙏
            <h4 className="font-bold mt-3">Worship & Breakouts</h4>
          </div>

        </div>

        <div className="flex gap-5 mt-12">

          <button
            onClick={() =>
              window.open(
                "https://faithmissionministriesinc.subspla.sh/kt8z85s",
                "_blank",
                "noopener,noreferrer"
              )
            }
            className="bg-[#BE2D69] hover:bg-[#A82059] text-white px-10 py-4 rounded-full font-bold transition"
          >
            Register Now
          </button>

          <button
            className="border-2 border-[#BE2D69] text-[#BE2D69] hover:bg-[#BE2D69] hover:text-white px-10 py-4 rounded-full font-bold transition"
          >
            View Details
          </button>

        </div>

      </div>

    </div>

  </div>

</section>
    </main>
    </>
  );
}
